module.exports = __webpack_public_path__ + "static/media/sugestao-instalacao.382b4a65.png";